import { defineComponent as i, computed as s, createElementBlock as m, createCommentVNode as l, openBlock as u, createVNode as d, createTextVNode as f, unref as g } from "vue";
import { ScalarIcon as h } from "@scalar/components";
import { makeUrlAbsolute as p } from "@scalar/oas-utils/helpers";
const k = ["href"], L = /* @__PURE__ */ i({
  __name: "OpenApiClientButton",
  props: {
    buttonSource: {},
    source: { default: "api-reference" },
    isDevelopment: { type: Boolean },
    integration: {},
    url: {}
  },
  setup(o) {
    const c = s(() => {
      const n = o.url ?? (typeof window < "u" ? window.location.href : void 0);
      if (!n)
        return;
      const t = p(n);
      if (!(t != null && t.length))
        return;
      const e = new URL(
        o.isDevelopment ? "http://localhost:5065" : "https://client.scalar.com"
      );
      if (e.searchParams.set("url", t), o.integration !== null && e.searchParams.set("integration", o.integration ?? "vue"), e.searchParams.set("utm_source", "api-reference"), e.searchParams.set("utm_medium", "button"), e.searchParams.set("utm_campaign", o.buttonSource), o.source === "gitbook") {
        e.searchParams.set("utm_source", "gitbook");
        const r = document.querySelector("img.dark\\:block[alt='Logo']"), a = document.querySelector("img.dark\\:hidden[alt='Logo']");
        r && r instanceof HTMLImageElement && e.searchParams.set("dark_logo", encodeURIComponent(r.src)), a && a instanceof HTMLImageElement && e.searchParams.set("light_logo", encodeURIComponent(a.src));
      }
      return e.toString();
    });
    return (n, t) => c.value ? (u(), m("a", {
      key: 0,
      class: "open-api-client-button",
      href: c.value,
      target: "_blank"
    }, [
      d(g(h), {
        icon: "ExternalLink",
        size: "xs",
        thickness: "2.5"
      }),
      t[0] || (t[0] = f(" Open API Client "))
    ], 8, k)) : l("", !0);
  }
});
export {
  L as default
};
